import { Container } from 'unstated';
import { isEmpty } from 'validator';

export interface IManufacturerDetailState {
  manufacturer: GQL.IManufacturer;
  errors: IValidationErrors;

  image: any;
}

export interface IManufacturerDetailStateProps {
  manufacturer: GQL.IManufacturer;
}

export interface IValidationErrors {
  name: string | undefined;
}

export class StateContainer extends Container<IManufacturerDetailState> {

  constructor(props: IManufacturerDetailStateProps) {
    super();

    this.state = {
      manufacturer: props.manufacturer,
      errors: {} as IValidationErrors,
      image: undefined
    };
  }

  public async onChange(key: string, val: any) {
    await this.setState({
      manufacturer: { ...this.state.manufacturer, [key]: val }
    });
  }

  public async onChangeMany(pairs: Array<{ key: string; val: any }>) {
    for (const pair of pairs) {
      await this.onChange(pair.key, pair.val);
    }
  }

  public async validate(): Promise<IValidationErrors> {
    const { manufacturer } = this.state;
    const errors = { ...this.state.errors };
    const message = 'This field is required';

    const validateEmpty = (input: string) => {
      if (input == undefined || isEmpty(input)) {
        return message;
      } else {
        return undefined;
      }
    };

    errors.name = validateEmpty(manufacturer.name || '');
    await this.setState({ errors: errors });
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Manufacturers/ManufacturerDetail/StateContainer.ts